import type { FigmaIconProps } from './types';

export const IconFigmaRotate = ({ size = 18, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.5C10.4834 1.5 11.9334 1.94005 13.1667 2.76416C14.4001 3.58825 15.3618 4.75925 15.9294 6.12964C16.4971 7.50008 16.6451 9.00852 16.3557 10.4634C16.0663 11.9181 15.3523 13.2546 14.3035 14.3035C13.2546 15.3523 11.9181 16.0663 10.4634 16.3557C9.00852 16.6451 7.50008 16.4971 6.12964 15.9294C4.75925 15.3618 3.58825 14.4001 2.76416 13.1667C1.94005 11.9334 1.5 10.4834 1.5 9C1.5 8.58579 1.83579 8.25 2.25 8.25C2.66421 8.25 3 8.58579 3 9C3 10.1867 3.35219 11.3466 4.01147 12.3333C4.67073 13.3199 5.60757 14.0888 6.70386 14.543C7.80016 14.9971 9.00658 15.1165 10.1704 14.885C11.3343 14.6535 12.4038 14.082 13.2429 13.2429C14.082 12.4038 14.6535 11.3343 14.885 10.1704C15.1165 9.00658 14.9971 7.80016 14.543 6.70386C14.0888 5.60757 13.3199 4.67073 12.3333 4.01147C11.347 3.35246 10.1876 3.00029 9.00146 3C7.30846 3.00672 5.68356 3.6675 4.46631 4.84424L2.78027 6.53027C2.48738 6.82317 2.01262 6.82317 1.71973 6.53027C1.42683 6.23738 1.42683 5.76262 1.71973 5.46973L3.41455 3.7749L3.70972 3.50244C5.16932 2.22152 7.04643 1.50736 8.99707 1.5H9Z"
      fill={color}
    />
    <path
      d="M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5C2.66421 1.5 3 1.83579 3 2.25V5.25H6C6.41421 5.25 6.75 5.58579 6.75 6C6.75 6.41421 6.41421 6.75 6 6.75H2.25C1.83579 6.75 1.5 6.41421 1.5 6V2.25Z"
      fill={color}
    />
  </svg>
);
